import { styled } from "@mui/material";

const FlexBox = styled("div")`
  display: flex;
  align-items: center;
`;

export default FlexBox;
